import { createSlice } from '@reduxjs/toolkit'

export const tootip1Slice = createSlice({
  name: 'tootip1',
  initialState: {
    value: {
        show: false, x: 0, y: 0, data: {
        
        }
    },
  },
  reducers: {
    setTooltip1: (state, action) => {
  
      state.value =action.payload
    },
    
   
  },
})

export const { setTooltip1 } = tootip1Slice.actions

export default tootip1Slice.reducer